// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".size-icon{width:16px;margin-bottom:2px}", "",{"version":3,"sources":["/app/src/components/icons/IconLogin/index.vue"],"names":[],"mappings":"AAaA,WACE,UAAW,CACX,iBAAkB","file":"index.vue?vue&type=style&index=0&lang=scss&","sourcesContent":["@import \"./src/assets/scss/_variable.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n.size-icon{\n  width: 16px;\n  margin-bottom: 2px;\n}\n"]}]);
// Exports
module.exports = exports;
